<template>
  <div class="content-bg">
    <div class="content" style="background: white">
      <div class="mainWrap"></div>
      <div class="bodyer_content">
        <div class="middle-body-left">
          <!-- <div class="current_location">
            当前位置：
            <span>
              <a href="index.htm" tppabs="http://www.gxlyzjz.cn/">&nbsp;&nbsp;首页</a>
            </span>

            >
            <span>
              <a
                href="index-1.jhtml.htm"
                tppabs="http://www.gxlyzjz.cn/xwdt/index.jhtml"
              >&nbsp;&nbsp; 新闻动态</a>
            </span>

            >
            <span>
              <a
                href="index-9.jhtml.htm"
                tppabs="http://www.gxlyzjz.cn/zjjj/index.jhtml"
              >&nbsp;&nbsp;质检聚焦</a>
            </span>
            <div class="lineS"></div>
          </div> -->

          <!-- 标题内容 -->
          <div class="body-title">
            <div class="btTitle" v-html="details.articleTitle"></div>
            <div class="bbBot">
              发布时间：
              <span class="body-title-time">{{details.gmtCreate}}</span>
              来源：
              <span class="body-src">{{details.articleSource?details.articleSource:'本站原创'}}</span>
              浏览次数：<span class="body-readNum"><span id="views">{{details.articleCount}}</span></span>
            </div>
            <div class="lineS"></div>
          </div>
        </div>

        <div class="content-txt" v-html="details.content">
        </div>

        <div class="content-link clearfix">
          <span class="prev-content">
            <i></i>上一篇：
            <span v-if="preGxArticle==null">没有了</span>
            <a
              v-if="preGxArticle!=null"
              @click="showContent(preGxArticle.id)"
            >{{formMartTitle(preGxArticle.articleTitle)}}</a>
          </span>
          <span class="next-content">
            下一篇：
            <a
              v-if="nextGxArticle!=null"
              @click="showContent(nextGxArticle.id)"
            >{{formMartTitle(nextGxArticle.articleTitle)}}</a>
            <span v-if="nextGxArticle==null">没有了</span>
            <i></i>
          </span>
        </div>
      </div>

      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import { getDatailsInfo,getDatailsColumnList } from "@/api/content/column";
export default {
  data() {
    return {
       details:{
         content:'',
       },
       preGxArticle:null,
       nextGxArticle:null,
       test:'', 
    };
  },
  created(){
    this.init();
  },
  
  watch:{
	//监听到路由（参数）改变
   '$route'(val, from) {
       // 拿到目标参数 val.query.id 去请求接口
       this.inits(val.query.id)
   }
},
  methods:{
    init(){
        this.id=this.$route.query.id;
        getDatailsInfo(this.id).then(response=>{
          this.details = response.data;
          if(this.details.preGxArticle!=null){
            this.preGxArticle=this.details.preGxArticle;
          }
          if(this.details.nextGxArticle!=null){
              this.nextGxArticle=this.details.nextGxArticle;
          }
        })
        // getDatailsColumnList(this.id).then(response=>{
        //   this.columnList = response.data;
        //   this.columnPidName=this.columnList.label;
        //   this.childrenLsit=this.columnList.children;
        //   this.childrenLsit.forEach(item=> {
        //     if(item.id==this.id){
        //       this.columnName=item.label;
        //       console.log("111"+item.label)
        //     }
        //   });
        // })
    },
    toDetails(id){
      this.$router.push({path:'/Aitrcle/Details',query:{id:id}})
    },
     inits(id){
        this.preGxArticle=null,
         this.nextGxArticle=null,
        this.id=id;
        getDatailsInfo(this.id).then(response=>{
          this.details = response.data;
          if(this.details.preGxArticle!=null){
            this.preGxArticle=this.details.preGxArticle;
          }
          if(this.details.nextGxArticle!=null){
              this.nextGxArticle=this.details.nextGxArticle;
          }
        })
        // getDatailsColumnList(this.id).then(response=>{
        //   this.columnList = response.data;
        //   this.columnPidName=this.columnList.label;
        //   this.childrenLsit=this.columnList.children;
        //   this.childrenLsit.forEach(item=> {
        //     if(item.id==this.id){
        //       this.columnName=item.label;
        //       console.log("111"+item.label)
        //     }
        //   });
        // })
    },
    showContent(id){
      this.$router.push({path:'/Aitrcle/Details',query:{id:id}})
    },
    formMartTitle(str) {
      if (str.length > 20) {
        return str.substring(0, 20) + "...";
      }
      return str;
    },

  }

};
</script>
<style  scoped>
@import '../styles/home.css';
@import '../styles/pages.css';
@import '../styles/style.css';
</style>
    




// WEBPACK FOOTER //
// src/components/Details.vue